import { render, staticRenderFns } from "./ReportEditPage.vue?vue&type=template&id=ca8f3940&"
import script from "./ReportEditPage.vue?vue&type=script&lang=ts&"
export * from "./ReportEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports